import type { Prompt } from "@1js/pl-types";
import React from "react";
import { useFlightContext } from "../../hooks/useFlightContext";
import { useHandoffService } from "../../hooks/useHandoffService";
import type { HandlePromptsTabSelected } from "../AllPrompts/AllPrompts.web.data";
import { useWorkgroups } from "../AllPrompts/useWorkgroups.hook";

export type UseYourPromptsProps = {
  handlePromptsTabSelected: HandlePromptsTabSelected;
  onBookmarkToggled?: () => void;
  setDialogOpen: (isOpen: boolean) => void;
  onDelete?: (prompt: Prompt) => void;
};

export const useYourPrompts = ({
  handlePromptsTabSelected,
  onBookmarkToggled,
  setDialogOpen,
  onDelete,
}: UseYourPromptsProps) => {
  useWorkgroups({ handlePromptsTabSelected });

  const { isFlightActive } = useFlightContext();
  const { chooseBestProductForHandoff } = useHandoffService();

  const handleOnBookmarkToggled = React.useCallback(() => {
    if (onBookmarkToggled) {
      onBookmarkToggled();
    }
  }, [onBookmarkToggled]);

  const handleOnDelete = React.useCallback(
    (prompt: Prompt) => {
      setDialogOpen(false);
      onDelete && onDelete(prompt);
    },
    [onDelete, setDialogOpen]
  );

  return {
    isFlightActive,
    handleOnBookmarkToggled,
    handleOnDelete,
    chooseBestProductForHandoff,
  };
};
